import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.csvCreate.header')) + "\n  ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-rocket-launch",
            "disabled": !_vm.importValidForm,
            "type": "submit"
          },
          on: {
            "click": _vm.createGateways
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.import')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c(VContainer, {
    staticClass: "n20-container pb-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VOverlay, {
    attrs: {
      "value": _vm.isBatchCreating
    }
  }, [_c(VProgressLinear, {
    attrs: {
      "color": _vm.color,
      "with": "5",
      "indeterminate": ""
    }
  }), _c('p'), _c(VProgressCircular, {
    attrs: {
      "color": _vm.color,
      "value": _vm.creationProgress,
      "width": "8",
      "size": "90",
      "rotate": "-90"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.creationProgress) + " %\n      ")])], 1), _c(VForm, {
    ref: "createForm",
    model: {
      value: _vm.importValidForm,
      callback: function ($$v) {
        _vm.importValidForm = $$v;
      },
      expression: "importValidForm"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "pt-2 pb-0 my-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.csvCreate.text'))
    }
  })])], 1), _c(VRow, [_c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('media-file-upload', {
    attrs: {
      "type": 'file',
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.copy.csvUpload'),
      "buttonIcon": 'fal fa-file-csv'
    },
    on: {
      "file": _vm.uploadedFile
    }
  }), _c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-download"
    },
    on: {
      "click": _vm.downloadSampleCsv
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.sampleCsvDownload')) + "\n          ")])], 1)], 1), _vm.gateways.length === 0 || _vm.gateways.filter(gw => gw.error).length > 0 ? _c(VInput, {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "rules": [v => false]
    }
  }) : _vm._e(), _vm.gateways.length > 0 ? [_c(VSwitch, {
    attrs: {
      "color": _vm.color,
      "label": `${_vm.$i18n_t('NiotaClassic.GWMonitoring.csvCreate.errorFilter')} (${_vm.gateways.filter(gw => gw.error).length} ${_vm.$i18n_t('NiotaClassic.GWMonitoring.csvCreate.errorCount')})`,
      "inset": ""
    },
    model: {
      value: _vm.prefilterError,
      callback: function ($$v) {
        _vm.prefilterError = $$v;
      },
      expression: "prefilterError"
    }
  }), _c(VDataTable, {
    staticClass: "mx-1",
    attrs: {
      "items": _vm.filteredRows,
      "headers": _vm.tableHeaders,
      "footer-props": _vm.tableFooterProps,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (props) {
        return [_c('tr', [_c('td', {
          class: props.item.error ? 'table-error-row' : ''
        }, [_vm._v("\n                " + _vm._s(_vm.get(props, 'item.idx')) + "\n              ")]), _c('td', {
          class: props.item.error ? 'table-error-row' : '',
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "250px"
          }
        }, [_vm._v("\n                " + _vm._s(props.item.title) + "\n              ")]), _c('td', {
          class: props.item.error ? 'table-error-row' : ''
        }, [props.item.eui ? _c('custom-fields-display-field', {
          attrs: {
            "value": props.item.eui,
            "type": "code",
            "copy": ""
          }
        }) : _vm._e()], 1), _c('td', {
          class: props.item.error ? 'table-error-row' : ''
        }, [_vm._v(_vm._s(props.item.fireflyGwId))]), _c('td', {
          class: props.item.error ? 'table-error-row' : '',
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "120px"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.originatorForId(props.item.properties.originator.id)) + "\n              ")]), _c('td', {
          class: props.item.error ? 'table-error-row' : '',
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "120px"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.accountForId(props.item.accountId)) + "\n              ")]), _c('td', {
          class: props.item.error ? 'table-error-row' : ''
        }, [_vm._v("\n                " + _vm._s(_vm.get(props, 'item.properties.manufacturer')) + "\n              ")]), _c('td', {
          class: props.item.error ? 'table-error-row' : '',
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "110px"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.get(props, 'item.coordinates.coordinates[1]')) + "\n              ")]), _c('td', {
          class: props.item.error ? 'table-error-row' : '',
          staticStyle: {
            "text-overflow": "ellipsis",
            "overflow": "hidden",
            "white-space": "nowrap",
            "max-width": "110px"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.get(props, 'item.coordinates.coordinates[0]')) + "\n              ")])]), props.item.error ? _c('tr', [_c('td', {
          staticClass: "table-error-row"
        }, [_c(VIcon, {
          attrs: {
            "color": "danger",
            "small": ""
          }
        }, [_vm._v("fal fa-exclamation-triangle")])], 1), _c('td', {
          staticClass: "table-error-row danger--text text-bold",
          attrs: {
            "colspan": "7"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.printError(props.item)) + "\n              ")]), _c('td', {
          staticClass: "table-error-row text-right",
          staticStyle: {
            "min-width": "86px"
          }
        }, [_vm.get(props, 'item.error.message') ? [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.resetGatewayError(props.index);
            }
          }
        }, [_vm._v("fal fa-undo")]), _vm._v("\n                   \n                ")] : _vm._e(), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.removeGateway(props.index);
            }
          }
        }, [_vm._v("\n                  fal fa-trash-alt\n                ")])], 2)]) : _vm._e()];
      }
    }], null, false, 1359130868)
  })] : _vm._e()], 2)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };